"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOffersRequestToJSON = exports.GetOffersRequestFromJSONTyped = exports.GetOffersRequestFromJSON = exports.instanceOfGetOffersRequest = void 0;
var runtime_1 = require("../runtime");
var GetOffersMockParameter_1 = require("./GetOffersMockParameter");
/**
 * Check if a given object implements the GetOffersRequest interface.
 */
function instanceOfGetOffersRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    isInstance = isInstance && "ipCountry" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "language" in value;
    return isInstance;
}
exports.instanceOfGetOffersRequest = instanceOfGetOffersRequest;
function GetOffersRequestFromJSON(json) {
    return GetOffersRequestFromJSONTyped(json, false);
}
exports.GetOffersRequestFromJSON = GetOffersRequestFromJSON;
function GetOffersRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
        'ipCountry': json['ipCountry'],
        'currency': json['currency'],
        'language': json['language'],
        'affiliateId': !(0, runtime_1.exists)(json, 'affiliateId') ? undefined : json['affiliateId'],
        'platform': !(0, runtime_1.exists)(json, 'platform') ? undefined : json['platform'],
        'page': !(0, runtime_1.exists)(json, 'page') ? undefined : json['page'],
        'pointOfSale': !(0, runtime_1.exists)(json, 'pointOfSale') ? undefined : json['pointOfSale'],
        'mock': !(0, runtime_1.exists)(json, 'mock') ? undefined : (0, GetOffersMockParameter_1.GetOffersMockParameterFromJSON)(json['mock']),
    };
}
exports.GetOffersRequestFromJSONTyped = GetOffersRequestFromJSONTyped;
function GetOffersRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
        'ipCountry': value.ipCountry,
        'currency': value.currency,
        'language': value.language,
        'affiliateId': value.affiliateId,
        'platform': value.platform,
        'page': value.page,
        'pointOfSale': value.pointOfSale,
        'mock': (0, GetOffersMockParameter_1.GetOffersMockParameterToJSON)(value.mock),
    };
}
exports.GetOffersRequestToJSON = GetOffersRequestToJSON;
